<template>
  <div class="bg-white pt-10">
    <section class="banner_category mx-auto w-full p-10 lg:p-20">
      <div
        class="rounded-lg p-10 lg:h-[435px]"
        style="
          background: linear-gradient(0deg, #f3a323 0%, #f3a323 100%),
            linear-gradient(
              180deg,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.42) 100%
            );
        "
      >
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 items-center">
          <img src="../assets/images/Kiri.svg" alt="" />
          <div class="text-5xl font-semibold text-white text-center">
            About Us
          </div>
          <img src="../assets/images/Kanan.svg" alt="" />
        </div>
      </div>

      <div class="category_desc mx-auto w-full mt-5">
        <div class="container mx-auto px-4 py-8 font-primary">
          <div class="p-3 mb-2">
            <h1 class="text-2xl font-bold text-gray-900 mb-4">
              About Xsportainment
            </h1>
            <p class="text-gray-700">
            <div v-html="data?.content"></div>
            </p>
          </div>

         

        </div>
        <!-- <div class="container mx-auto px-4 py-2 font-primary">
          <div class="p-6 mb-4">
            <h1 class="text-2xl font-bold text-gray-900 mb-4">
              Our Story
            </h1>
            <p class="text-gray-700">
              "Tidak hanya meningkatkan kebugaran fisik, rutin berolahraga juga
            mengurangi tingkat stres dan meningkatkan produktivitas di tempat
            kerja." - Penelitian oleh American College of Sports Medicine (ACSM)
            </p>
          </div>
        </div> -->
      </div>
    </section>
  </div>
</template>
<script>
import AuthService from "@/services/auth.service";
import webContentService from "@/services/web-content.service";
export default {
  data() {
    return {
     tenant:{},
     data:{},
    query:'about-us'
        
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  async mounted() {
     AuthService.getDataTenant().then(
        (response) => {
        var data = response.data;
        this.tenant = data;
        this.webSiteContent(this.tenant.id, this.tenant.code, this.query);
        },
        (error) => {
        this.content =
            (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString();
        }
    );
    

    
  },
  methods:{
    webSiteContent(id,code,query){
      webContentService.getData(id,code,query).then(
        (response) => {
        var data = response.data.data[0];
        this.data = data;
        },
        (error) => {
        this.content =
            (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString();
        }
    );
    }
  }
};
</script>